import { getItemFromStorage, removeItemFromStorage, setItemToStorage, setItemToStorageAsync, TYPE_SESSION_STORAGE, } from '../local-storage-utils/local-storage.utils';
export function getItemSessionStorage(key) {
    return getItemFromStorage(key, TYPE_SESSION_STORAGE);
}
export function setItemSessionStorage(key, value) {
    return setItemToStorage(key, value, TYPE_SESSION_STORAGE);
}
export function setItemSessionStorageAsync(key, value) {
    return setItemToStorageAsync(key, value, TYPE_SESSION_STORAGE);
}
export function removeItemSessionStorage(key) {
    return removeItemFromStorage(key, TYPE_SESSION_STORAGE);
}
